var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardoutstandingloanbalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4038 20.7897H29.5659V23.113H34.4038V20.7897Z",
    fill: "#FF969F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88594 18.345C3.73027 16.0479 5.35623 14.1286 7.44298 12.9113V8.55359C9.33656 8.55359 10.9307 9.83161 11.4127 11.5719C11.8364 11.5196 12.2678 11.4923 12.7056 11.4923H20.6548C26.4316 11.4923 31.1147 16.1754 31.1147 21.9522C31.1147 26.9413 27.6216 31.114 22.9478 32.1593V36.1063H18.7687V32.4121H14.5917V36.1064H10.4126V32.1581C6.9267 31.3782 4.09711 28.8602 2.88446 25.5596H0V18.345H2.88594Z",
    fill: "#FF717D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6802 11.4923H12.7056C12.2678 11.4923 11.8363 11.5197 11.4126 11.5719C10.9307 9.83168 9.33663 8.55359 7.4429 8.55359V12.9113C5.35623 14.1286 3.73019 16.0479 2.88587 18.345H0V25.5596H2.88438C4.09711 28.8602 6.92663 31.3782 10.4125 32.1581V36.1064H14.5916V32.4122H16.6801L16.6802 11.4923Z",
    fill: "#FF969F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6809 8.55285C19.0427 8.55285 20.9573 6.63823 20.9573 4.27643C20.9573 1.91462 19.0427 0 16.6809 0C14.319 0 12.4044 1.91462 12.4044 4.27643C12.4044 6.63823 14.319 8.55285 16.6809 8.55285Z",
    fill: "#FBB500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44348 19.5561C8.11294 19.5561 8.65564 19.0134 8.65564 18.344C8.65564 17.6745 8.11294 17.1318 7.44348 17.1318C6.77402 17.1318 6.23132 17.6745 6.23132 18.344C6.23132 19.0134 6.77402 19.5561 7.44348 19.5561Z",
    fill: "#E21B4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.254 13.1825H12.105V15.3767H21.254V13.1825Z",
    fill: "#E21B4E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6792 13.1825H12.105V15.3767H16.6792V13.1825Z",
    fill: "#FF717D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6796 0C14.3177 0 12.4031 1.91467 12.4031 4.2765C12.4031 6.63833 14.3177 8.553 16.6796 8.553V0Z",
    fill: "#FFCE47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardoutstandingloanbalance);
export default __webpack_public_path__ + "static/media/dashboardoutstandingloanbalance.40b0e15e6db922baf6f7ea1bfad650c2.svg";
export { ForwardRef as ReactComponent };